import type { EnergyLabel } from '@/shared/types'

export const ENERGY_LABEL_COLORS: Record<EnergyLabel, string> = {
  'A+': '#6CB33F',
  A: '#8DC73F',
  B: '#BDD630',
  C: '#D7DF23',
  D: '#FFF200',
  E: '#FDB913',
  F: '#F37021',
  G: '#ED6B18',
  H: '#E30613',
}

export const getEnergyLabelColor = (label: EnergyLabel): string => {
  return ENERGY_LABEL_COLORS[label] || '#464A54'
}
